export const SITE_SETTINGS_QUERY = `
  *[_type == "siteSettings"][0]{
    dispensaryName,
    dispensaryLicenseNumber,
    logo {
      asset->{
        url,
        originalFilename,
        size
      }
    },
    favicon {
      asset->{
        url
      }
    },
    social {
      facebook,
      instagram,
      x,
      youtube
    }, 
    featuredBrands,
    themeColors,
  }
`

export const MENU_QUERY = `
  *[_type == "menu"][0]{
    mainMenu[] {
      ...,
      _type == "menuGroup" => {
        title,
        items[] {
          title,
          link
        }
      },
      _type == "menuItem" => {
        title,
        link
      }
    },
    footerMenu[] {
      ...,
      _type == "menuGroup" => {
        title,
        items[] {
          title,
          link
        }
      },
      _type == "menuItem" => {
        title,
        link
      }
    },
    legalMenu[] {
      title,
      link
    }
  }
`

export const HOMEPAGE_HEADERS_QUERY = `
  *[
    _type == "homepageHeader" &&
    !(_id in path("drafts.**"))
  ] | order(orderRank) {
    _createdAt,
    _id,
    title,
    uppercaseTitle,
    body,
    uppercaseBody,
    buttonText,
    buttonUrl,
    backgroundImage,
    mobileBackgroundImage,
    startDate,
    endDate,
    useStartDate,
    useEndDate
  }
`;


export const HOME_PAGE_QUERY = `
  *[_id == "homePage"][0]{
    metaTitle,
    metaDescription,
    content[] {
      ...,
      _type == "categorySlider" => {
      title,
      categories[]->{
        _id,
        title,
        category,
        slug,
        description,
        mediaType,
        icon,
        customIcon
      }
    },
     _type == "productSlider" => {
      title,
      subtitle,
      icon,
      filters,
      excludeProductId,
      category->{
        title,
        category,
        slug,
        mediaType,
        icon,
        customIcon
      }
    },
      _type == "faqs" => {
        ...,
        faqCategory->{
          title,
          _id
        },
        faqs[]->
      }
    }
  }
`

export const PAGE_QUERY = `
  *[_type == "page" && slug.current == $slug][0]{
    ...,
    content[] {
      ...,
      _type == "faqs" => {
        ...,
        faqCategory->{
          title,
          _id
        },
        faqs[]{
          ...,
          _type == "faq" => @->,
        }
      },
      _type == "categorySlider" => {
        title,
        categories[]->{
          _id,
          title,
          category,
          slug,
          description,
          mediaType,
          icon,
          customIcon
        }
      },
      _type == "productSlider" => {
        title,
        subtitle,
        icon,
        filters,
        excludeProductId,
        category->{
          title,
          category,
          slug,
          mediaType,
          icon,
          customIcon
        }
      }
    }
  }
`;


export const SHOP_CATEGORIES_QUERY = `
  *[_type == "shopCategories"] {
    _id,
    title,
    category,
    slug {
      current
    },
    description,
    mediaType,
    icon,
    customIcon
  }
`

export const LOCATIONS_QUERY = `
  *[_type == "locations"] {
    _id,
    city,
    zipcodes,
    storeId
  }
`

export const BLOG_POSTS_QUERY = (start = 0, end = 9) => `
*[
  _type == "post" &&
  defined(slug.current) &&
  defined(publishedAt) &&
  publishedAt < now() &&
  !(_id in path("drafts.**"))
] | order(publishedAt desc)[${start}...${end}] {
  _id,
  title,
  slug,
  author -> {
    name,
    image,
  },
  categories[] -> {
    title
  },
  mainImage
}
`;

export const BLOG_SLIDER_POSTS_QUERY = `
  *[_type == "post" && defined(slug.current) && defined(publishedAt) && publishedAt < now() && !(_id in path("drafts.**"))]
  | order(publishedAt desc)[0...5] {
    _id,
    title,
    slug,
    publishedAt,
    excerpt,
    mainImage,
    categories[]->{
      title
    }
  }
`;

export const SPECIALS_GRID_QUERY = `
*[_type == "specialsGrid"][0]{
  title,
  subtitle,
}
`;